module.exports = __webpack_public_path__ + "8ec2df8cbd80e17eeb246230c33613d1.jpg";